export default __webpack_public_path__ + "static/solarHomeB-e89bcb2a0ca9a29c4bd2a1ac344cb64e.jpeg";